export default {
	Payroll: "Payroll",
	PayrollActivity: "PayrollActivity",
	PayrollActivityDetail: "PayrollActivityDetail",
	PaymentSummary: "PaymentSummary",
	PaymentSummaryEmployee: "PaymentSummaryEmployee",
	PaymentSummaryEmployer: "PaymentSummaryEmployer",
	PayrollActivitySummary: "PayrollActivitySummary"
};
